<template>
  <div class="page_tax">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs2 flex">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>个税</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="所得明细" name="所得明细"></el-tab-pane>
          <el-tab-pane label="个税草稿" name="个税草稿"></el-tab-pane>
          <el-tab-pane label="待确认" name="待确认"></el-tab-pane>
          <el-tab-pane label="待申报" name="待申报"></el-tab-pane>
          <el-tab-pane label="申报中" name="申报中"></el-tab-pane>
          <el-tab-pane label="申报成功" name="申报成功"></el-tab-pane>
          <el-tab-pane label="申报失败" name="申报失败"></el-tab-pane>
          <el-tab-pane label="扣除信息" name="扣除信息"></el-tab-pane>
          <el-tab-pane label="预扣实缴差异" name="预扣实缴差异"></el-tab-pane>
          <el-tab-pane label="个税申报设置" name="个税申报设置"></el-tab-pane>
        </el-tabs>
        <div>
          <el-form :model="timeForm" ref="timeForm" label-width="160px">
            <el-form-item label="零申报自动生成时间" size="small">
              <div class="flex">
                <el-select v-model="timeForm.zeroDate" size="small" clearable filterable style="width:140px;margin-right:20px" placeholder="">
                  <el-option v-for="(item, index) in 7" :key="index" :value="item" :label="item + '日'"></el-option>
                  <el-option value="31" label="每月最后一天"></el-option>
                </el-select>
                <el-time-picker v-model="timeForm.zeroTime" placeholder="" value-format="HH:mm:ss">
                </el-time-picker>
              </div>
            </el-form-item>
            <el-form-item label="每月确认截止时间" size="small">
              <div class="flex">
                <el-select v-model="timeForm.lastDate" size="small" clearable filterable style="width:140px;margin-right:20px" placeholder="">
                  <el-option v-for="(item, index) in 7" :key="index" :value=" '0' + item" :label="item + '日'"></el-option>
                  <el-option value="15" label="15日"></el-option>
                  <el-option value="31" label="每月最后一天"></el-option>
                </el-select>
                <el-time-picker v-model="timeForm.lastTime" placeholder="" value-format="HH:mm:ss">
                </el-time-picker>
              </div>
            </el-form-item>
            <el-form-item label="每月自动生成个税草稿" size="small">
              <el-radio-group v-model="timeForm.automaticallyGenerated">
                <el-radio :label="0">不自动生成</el-radio>
                <el-radio :label="1">自动生成上月</el-radio>
                <el-radio :label="2">自动生成本月</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="生成个税草稿时间" size="small">
              <div class="flex">
                <el-select v-model="timeForm.createDate" size="small" clearable filterable style="width:140px;margin-right:20px" placeholder="">
                  <el-option v-for="(item, index) in 7" :key="index" :value="item" :label="item + '日'"></el-option>
                  <el-option value="31" label="每月最后一天"></el-option>
                </el-select>
                <el-time-picker v-model="timeForm.createTime" placeholder="" value-format="HH:mm:ss">
                </el-time-picker>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-preventReClick @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="ftabBtn flex">
          <el-popconfirm :title="'请确定选中的' + multipleSelection.length + '家公司申报？'" style="margin:0 10px;" @confirm="SetInComeDeclarationSetting('true')" v-if="listQuery.isDeclare=='false'">
            <el-button type="success" slot="reference" size="small" :loading="setDeclareLoading">选择申报</el-button>
          </el-popconfirm>

          <el-popconfirm :title="'请确定选中的' + multipleSelection.length + '家公司不申报？'" style="margin:0 10px;" @confirm="SetInComeDeclarationSetting('false')" v-if="listQuery.isDeclare=='true'">
            <el-button type="danger" slot="reference" size="small" :loading="setDeclareLoading">选择不申报</el-button>
          </el-popconfirm>

          <el-popconfirm title="请确定是否全部公司申报？" style="margin:0 10px;" @confirm="SetAllCompanyDeclare">
            <el-button type="warning" slot="reference" size="small" :loading="isBtnLoading">全部公司申报</el-button>
          </el-popconfirm>
          <el-button type="primary" size="small" :loading="expLoading" @click="exportList" v-preventReClick>导出</el-button>
        </div>
        <el-tabs v-model="listQuery.isDeclare" @tab-click="changeTab2">
          <el-tab-pane label="申报" name="true"></el-tab-pane>
          <el-tab-pane label="不申报" name="false"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="payRollCompanyName" label="主体名称" min-width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taxId" label="税号" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taxAccounting" label="报税会计" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="wasPaidLastMonth" label="上月是否发薪" min-width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.wasPaidLastMonth == true ? '是' : '否'}}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="选择申报开始生效时间" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.createTime ? row.createTime.replace('T',' ') : ''}}</template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="Number(listQuery.PageModel.Rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          payRollCompanyId: '', //公司
          taxId: '',
          isDeclare: 'true', // true 申报  false不申报
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          }
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        multipleSelection: [],
        totalCount: 0,
        activeName: '个税申报设置',
        loading: false,
        legList: [],
        isBtnLoading: false,
        timeLoading: false,
        setDeclareLoading: false,
        expLoading: false,
        timeForm: {
          zeroDate: '', //零申报自动生成日期
          zeroTime: '', //零申报自动生成时间
          lastDate: '', ///每月确认截止日期
          lastTime: '', //每月确认截止时间
          createDate: '', //生成个税草稿日期
          createTime: '', //生成个税草稿时间
          automaticallyGenerated: 0, //每月自动生成个税草稿 0不自动生成 1自动生成上月 2自动生成本月
        }
      }
    },
    created() {
      // this.getButtonPower();
      this.getlegalsubjectlist();
      this.getProList();
      this.GetInComeDeclarePageList();
      this.GetInComeTimeSetting();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/calcSalary',
          powerEnName: 'sarary'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.GetInComeDeclarePageList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.GetInComeDeclarePageList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.GetInComeDeclarePageList();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //获取设置的申报公司列表
      GetInComeDeclarePageList() {
        this.loading = true;
        xz.GetInComeDeclarePageList(this.listQuery).then(res => {
          try {
            this.tableData = res.data.data;
            this.totalCount = Number(res.data.pageModel.totalCount);
            this.loading = false;
          } catch (e) {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
            this.$message.error('获取列表失败')
          }
        })
      },
      //获取申报时间设置
      GetInComeTimeSetting() {
        xz.GetInComeTimeSetting().then(res => {
          if (res.status == 'ok') {
            this.timeForm.automaticallyGenerated = res.data.automaticallyGenerated;
            if (res.data.zeroDeclarationStartTime) {
              this.timeForm.zeroDate = new Date(res.data.zeroDeclarationStartTime).getDate();
              this.timeForm.zeroTime = res.data.zeroDeclarationStartTime.split('T')[1]
            }
            if (res.data.zeroDeclarationEndTime) {
              this.timeForm.lastDate = new Date(res.data.zeroDeclarationEndTime).getDate();
              this.timeForm.lastTime = res.data.zeroDeclarationEndTime.split('T')[1]
            }
            if (res.data.draftInComeTaxTime) {
              this.timeForm.createDate = new Date(res.data.draftInComeTaxTime).getDate();
              this.timeForm.createTime = res.data.draftInComeTaxTime.split('T')[1]
            }
          }
        })
      },
      //选择全部公司申报
      SetAllCompanyDeclare() {
        if (!this.isBtnLoading) {
          this.isBtnLoading = true;
          let data = {
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
          }
          xz.SetAllCompanyDeclare(data).then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功！')
              this.isBtnLoading = false;
              this.GetInComeDeclarePageList();
            } else {
              this.$message.error(res.msg)
              this.isBtnLoading = false;
            }
          })
        }
      },
      SetInComeDeclarationSetting(type) {
        if (!this.setDeclareLoading) {
          if (this.multipleSelection.length > 0) {
            this.setDeclareLoading = true;
            let arr = [];
            this.multipleSelection.forEach((element, index) => {
              arr.push(element.id)
              if (this.multipleSelection.length == index + 1) {
                let data = {
                  ids: arr,
                  isDeclare: type
                }
                xz.SetInComeDeclarationSetting(data).then(res => {
                  if (res.status == 'ok') {
                    this.$message.success('保存成功！')
                    this.setDeclareLoading = false;
                    this.GetInComeDeclarePageList();
                  } else {
                    this.$message.error(res.msg)
                    this.setDeclareLoading = false;
                  }
                })
              }
            });
          } else {
            this.$message.warning('请至少选择一个公司')
          }
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      changeTab(tab, event) {
        if (tab.index == '0') {
          this.$router.push({
            path: '/incomeDtl'
          })
        } else if (tab.index == '7' || tab.index == '8') {
          this.$router.push({
            path: '/deductionInfo'
          })
        } else {
          this.$router.push({
            path: '/tax',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      //设置申报时间
      onSubmit() {
        this.timeLoading = true;
        let data = {
          id: '',
          zeroDeclarationStartTime: '',
          zeroDeclarationEndTime: '',
          automaticallyGenerated: 0,
          draftInComeTaxTime: ''
        }
        if (this.timeForm.zeroDate && this.timeForm.zeroTime) {
          data.zeroDeclarationStartTime = '2024-05-' + this.timeForm.zeroDate + 'T' + this.timeForm.zeroTime
        }
        if (this.timeForm.lastDate && this.timeForm.lastTime) {
          data.zeroDeclarationEndTime = '2024-05-' + this.timeForm.lastDate + 'T' + this.timeForm.lastTime
        }
        if (this.timeForm.createDate && this.timeForm.createTime) {
          data.draftInComeTaxTime = '2024-05-' + this.timeForm.createDate + 'T' + this.timeForm.createTime
        }
        data.automaticallyGenerated = this.timeForm.automaticallyGenerated;
        xz.SetInComeTimeSetting(data).then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('保存成功');
              this.timeLoading = false;
            } else {
              this.$message.error(res.msg);
              this.timeLoading = false;
            }
          } catch (e) {
            this.$message.error('系统出错');
            this.timeLoading = false;
          }
        })
      },
      changeTab2() {
        this.GetInComeDeclarePageList();
      },
      exportList() {
        this.expLoading = true;
        let data = {
          payRollCompanyId: this.listQuery.payRollCompanyId,
          taxId: this.listQuery.payRollCompanyId,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          isDeclare: this.listQuery.isDeclare,
        }
        xz.ExportInComeDeclarePageList(data).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = this.listQuery.isDeclare == 'true' ? "申报公司列表.xlsx" : '不申报公司列表.xlsx';
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.expLoading = false;
          } catch (e) {
            this.expLoading = false;
            this.$message.error('导出异常')
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .red {
    color: red;
  }

  .success {
    color: #19BD92;
  }

  .Checking {
    display: flex;
    justify-content: center;
  }

  .CheckingTips {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
</style>
<style>
  .page_tax .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tax .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tax .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tax .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tax .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tax .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>